<template>
    <v-tooltip v-if="procuration" bottom max-width="360">
        <template #activator="{ on }">
            <span v-on="on">
                <ui-badge :text="text" :tone="tone" />
            </span>
        </template>
        <div class="psb-tip">
            <div><strong>Procuração {{ procuration.document_code }}</strong> · modelo v{{ procuration.template_version }}</div>
            <div v-if="procuration.signer">Assinada por {{ procuration.signer.name || "—" }} ({{ procuration.signer.cpf_masked || "CPF não identificado" }})</div>
            <div v-if="procuration.signing_time">Em {{ procuration.signing_time | defaultDate("DD/MM/YYYY HH:mm") }}</div>
            <div v-if="procuration.signer_kind === 'pj'">Pessoa jurídica: conferir a procuração e os documentos da empresa.</div>
            <div v-if="procuration.message" class="mt-1">{{ procuration.message }}</div>
        </div>
    </v-tooltip>
</template>

<script>
// Selo da procuracao gerada pelo modelo (associacao procurador-credor).
export default {
    name: "ProcurationSourceBadge",

    props: {
        procuration: { type: Object, default: null },
    },

    computed: {
        text() {
            const p = this.procuration;
            if (p.auto_validation_result === "pass") return `Modelo v${p.template_version} · GOV.br validado`;
            return `Modelo v${p.template_version} · análise manual`;
        },
        tone() {
            return this.procuration.auto_validation_result === "pass" ? "success" : "warning";
        },
    },
};
</script>

<style scoped>
.psb-tip { font-size: 12.5px; line-height: 1.5; }
</style>
